export default {
  title: 'Mot de passe',
  confirmPassword: {
    label: 'Confirmer le mot de passe',
    PasswordConfirmation: 'Le mot de passe et la confirmation ne sont pas identiques.',
  },
};
